import React from 'react';
import { Route, Switch } from 'react-router-dom';
import P, { InferProps } from 'prop-types';
import TicketConfigGrid from './ticket-config-grid';

function TicketConfig({ match }: InferProps<typeof TicketConfig.propTypes>) {
  return (
    <Switch>
      <Route exact path={match.url} component={TicketConfigGrid} />
    </Switch>
  );
}

TicketConfig.propTypes = {
  match: P.shape({
    url: P.string.isRequired,
  }).isRequired,
};

export default TicketConfig;
